import React, { useState } from 'react';
import { useMediaQuery } from "@mui/material";
import Thanks from './Thanks';
import { useNavigate } from 'react-router-dom';
import { getStorageItem } from "../../../src/utils/sessionStorage";
import axios from "axios";
import "./index.scss";

const ContactedtUs = () => {
  const navigate = useNavigate();
  const accessToken = getStorageItem("token");
  const mobileView = useMediaQuery("(max-width:920px)");
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.email && !formData.message && !formData.phone) return;
      var contact = {
        method: "post",
        url: global.config.ROOTURL.prod + "/auth/contactus",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        data: {
          email: formData.email,
          message: formData.message,
          phone: formData.phone,
        },
        json: true,
      };

    axios(contact)
      .then((response) => {
        if (response.data.message === "email sent") {
          navigate('/thank-you');
        }
      })
      .catch((error) => {
        console.log(error)
      });
  };


  return (
    <div style=
      {mobileView ? mobilestyle : style}
      className='form-main1'
    >
      <form
        className='Contact-form-conatiner1'
        onSubmit={(e) => handleSubmit(e)}
      >
        <h3 style={{ textAlign: "center", paddingBottom: "2em" }}>CONTACT US </h3>
        <div className="horizontal-input">
          <label>Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="horizontal-input">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>
        <input type="hidden" name="_next" />
        <div className="horizontal-input">
          <label>Phone:</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="horizontal-input">
          <label>Message:</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            required
          ></textarea>
        </div>
        <button type="submit">Send</button>
      </form>
    </div>
  );
};

const style = {
  display: "flex",
  position: "relative",
  top: "0rem"
}
const mobilestyle = {
  display: "flex",
  // flexDirection: "column"
}

export default ContactedtUs;

